Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function () {
  $('.productmain-price').show();



  setTimeout(function () {
    $(".rc-radio").wrapAll('<div class="parent-wrapper"></div>');
    $(".rc-selling-plans-dropdown__select").addClass("select");
    $(".onetime-radio  .rc-radio__label").text("One-time Purchase");
    const newIcon = `
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="16px" height="16px" class="reload-icon mr-2">
          <path d="M25,2C12.297,2,2,12.297,2,25s10.297,23,23,23s23-10.297,23-23S37.703,2,25,2z M25,11c1.657,0,3,1.343,3,3s-1.343,3-3,3 s-3-1.343-3-3S23.343,11,25,11z M29,38h-2h-4h-2v-2h2V23h-2v-2h2h4v2v13h2V38z"></path>
          </svg>
        `;
    $(".rc-subscription-details__button").html(newIcon);
  }, 1800);
  $(document).on("change", ".rc-radio", function () {
    $(".rc-selling-plans-dropdown__select").addClass("select");
    $(".rc_widget__option__plans__dropdown").addClass("select");
  });

  // START: - quick view popup recharge widget
  $(document).on("change", '.custom-rc-radio input[type="radio"]', function () {
    var $_this = $(this).closest(".custom-rc-radio");

    // Remove active class from all custom-rc-radio elements
    $(".custom-rc-radio").removeClass("rc-radio--active");

    // Add active class to the closest custom-rc-radio element
    $_this.addClass("rc-radio--active");

    // Remove active class from all options-wrap elements
    $(".options-wrap").removeClass("active");

    // Add active class to the closest options-wrap element of the current custom-rc-radio
    $_this.closest(".options-wrap").addClass("active");
  });
  // END: - quick view popup recharge widget
});
window.updatePrice = function () {
  var price = JSON.parse($("[data-variant]").html()).price,
    qty = parseInt($('[name="quantity"]').val()) || 1,
    newPrice = price * qty;
  console.log(price, qty, newPrice);
  $(".productmain-price").html(
    Shopify.formatMoney(newPrice, Shopify.money_format)
  ).show();
};

$(document).on("change", ".trigger_sp__select", function () {
  $("#selling-plan-select").val($(this).val());
});

window.onVarinatChange = function (variant) {
  $('.productmain-price').hide();
  setTimeout(function () {
    console.log(variant, "<<<<<varinat");
    window.updatePrice();
  }, 700);
};

// START: - customer registration modal
$(document).ready(function () {
    // Setup sign-up form triggers for any link/button with href="#open-sign-up-form"
    const signUpTriggers = document.querySelectorAll('a[href="#open-sign-up-form"], button[href="#open-sign-up-form"]');
    const registrationModal = document.getElementById('registration-modal');
  
    if (signUpTriggers.length > 0 && registrationModal) {
      signUpTriggers.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          registrationModal.show();
        });
      });
      console.log('Sign-up form triggers initialized:', signUpTriggers.length, 'elements found');
    }
});